export const sortOptions = [
  { key: 'ad_size', label: 'Ad Size' },
  { key: 'agency_title', label: 'Agency Title' },
  { key: 'agent_ad_count', label: 'Agent Ad Count' },
  { key: 'auction_date', label: 'Auction Date' },
  { key: 'price', label: 'Price' },
  { key: 'promo', label: 'Promo' },
  { key: 'state_name', label: 'State Name' },
  { key: 'suburb_name', label: 'Suburb Name' },
  { key: 'street_name', label: 'Street Name' },
  { key: 'street_number', label: 'Street Number' },
  { key: 'unit_number', label: 'Unit Number' },
]

export default sortOptions
